export default __webpack_public_path__ + "static/media/login-background.dee62bb1.svg";